// @i18n-ignore-file
const theme = {
  colors: {
    primary: `#21201F`,
    secondary: `#FFF`,
    greyLight: `#979797`,
    greyLighter: `#E3E3E3`,
    green: `#2C584B`,
    lightGreen: `#5AC08E`,
    yellow: `#F0B44F`,
    red: `#A43E46`,
    brightRed: '#db3333',
    salmon: `#EECEBE`,
    maroon: `#800000`,
    silver: `#C4C4C4`,
    charcoalGrey: '#2B2D2F',
    lightCharcoalGrey: `#3E3E3E`,
    lightPink: `#FFF5F0`,
    ashGrey: `#6C6C6C`,
    darkGrey: '#4f4f4f',
    doveGrey: '#686868',
    shamrockGreen: `#0F9D58`,
    alabaster: '#fcfcfc',
    whiteSmoke: '#f8f8f8',
    cagliariSibling: '#BFCDB3',
    greenCyanMediumDark: '#3D5A4F',
    white80Opacity: '#ffffff80',
    greenCyanMediumLight: '#a5a7a6',
    veryLightGray: '#e8e8e8',
    whisper: '#efebeb',
    mistGrey: '#b9b8ad',
    newSiteRed: '#AF3535',
    cantaloupe: '#ffa273',
    offWhite: '#EEEEEC',
    newSiteBlack: '#21201F',
    darkGray2: '#757575',
    darkGray3: '#717171',
    azureBlue: '#0066cc',
    darkAzureBlue: '#004499',
  },
  fonts: {
    primary: `grosa, sans-serif`,
    secondary: `ivy-text, serif`,
    heading: `grosa, sans-serif`,
    grosa: `grosa, sans-serif`,
    ivyHeadline: `ivy-headline, serif`,
    ivyText: `ivy-text, serif`,
  },
  breakpoints: {
    mobile: 375,
    tablet: 768,
    desktopSmall: 960,
    desktop: 1440,
  },
  spacings: {
    mobile: 22,
  },
  header: {
    scrollBackgroundColor: 'white',
    mobile: {
      color: '#000000',
      height: 59,
      borderBottom: '1px solid rgba(0,0,0,0.1)',
    },
    desktop: {
      color: '#000000',
      height: 79,
      borderBottom: '1px solid rgba(0,0,0,0.1)',
    },
  },
  announcementBar: {
    mobile: {
      height: 40,
    },
    desktop: {
      height: 50,
    },
  },
  zendeskWidget: {
    productPage: {
      bottom: 75,
    },
    default: {
      bottom: 0,
    },
  },
}

// To also use in gatsby-node
module.exports = theme
